import React, { FC } from 'react';
import { useFeatureFlag } from 'src/shared/feature-flags';
import { ProofListPageSkeleton } from '../proofing/proofingSkeleton';
import ProofingHubInternal from './internal';
import { ProofingHubPageSkeleton } from './proofingHubSkeleton';

const ProofListPage = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: 'proofList' */ '../proofing/proofList/ProofListPage'));

const ProofingHubRoute: FC = () => {
    const isProofingEnabled = useFeatureFlag('proofing');

    return isProofingEnabled ? <ProofListPage /> : <ProofingHubInternal />;
};

export const ProofingHubRouteSkeleton: FC = () => {
    const isProofingEnabled = useFeatureFlag('proofing');

    return isProofingEnabled ? <ProofListPageSkeleton /> : <ProofingHubPageSkeleton />;
};

export default ProofingHubRoute;
